import { useStaticQuery, graphql } from 'gatsby'

const useAcUnitsCode = () => {
  const query = useStaticQuery(graphql`
    {
      allStrapiAcUnitsCodes (filter: {name: {nin: ["ICDA", "Ciencias Químicas"]}}) {
        nodes {
          strapiId
          name
          code
        }
      }
    }
  `)
  return query
}

export default useAcUnitsCode